import { useEffect, useReducer } from 'react';

import { Conversation } from '@web/conversations/types/Conversation';
import { Message } from '@web/conversations/types/Message';

import { conversationInitialState } from '../conversationProvider.consts';
import { reducer } from '../conversationProvider.reducer';
import { createInitialState } from '../conversationProvider.utils';

import { useCreateConversationActions } from './useCreateConversationActions';

type Props = {
  conversation: Conversation;
  messages: Message[];
  selectedMessageId: ID | null;
};

export const useConversationContext = ({ conversation, messages, selectedMessageId }: Props) => {
  const [state, dispatch] = useReducer(reducer, conversationInitialState, (initialState) =>
    createInitialState(conversation, initialState, {
      messages,
      selectedMessageId,
    })
  );
  const actions = useCreateConversationActions(dispatch);

  useEffect(() => {
    actions.setConversation({
      state: createInitialState(conversation, conversationInitialState, {
        messages,
        selectedMessageId,
      }),
    });
  }, [actions, conversation, messages, selectedMessageId]);

  return {
    actions,
    state,
  };
};
